class UpsellPopup extends HTMLElement{
    constructor(){
        super()
        this.classes = {
            bodyClass: 'promo-popup--open',
            activeClass: 'is-active',
            closingClass: 'is-closing'
          };
          this.popup = this.querySelector('.upsell-popup');
          this.closeBtn = this.querySelectorAll('[upsell-popup-toggle]')
          this.closeBtn.forEach((button) => {
            button.addEventListener('click', this.onButtonClick.bind(this));
          });
        
    }
    onButtonClick(event) {
        event.preventDefault();
        document.querySelector('.upsell-popup').classList.contains(this.classes.activeClass) ? this.closeUpsell() : this.openUpsell();
    }
    
    openUpsell() {
      document.querySelector('.upsell-popup').classList.add(this.classes.activeClass);
        setScrollbarWidth();
        document.body.classList.add(this.classes.bodyClass);
      this.closeBtn = this.querySelectorAll('[upsell-popup-toggle]')
      this.closeBtn.forEach((button) => {
        button.addEventListener('click', this.onButtonClick.bind(this));
      });
    }
    closeUpsell() {
        document.querySelector('.upsell-popup').classList.add(this.classes.closingClass);
        document.getElementById('cart').dispatchEvent(new Event('submit'))
        setTimeout(() => {
          document.querySelector('.upsell-popup').classList.remove(this.classes.activeClass);
          document.querySelector('.upsell-popup').classList.remove(this.classes.closingClass);
          document.body.classList.remove(this.classes.bodyClass);
        }, 500);
        window.location.href = '/checkout';
      
    }
    connectedCallback() {
      if (Shopify.designMode) {
        this.onShopifySectionLoad = this.onSectionLoad.bind(this);
        this.onShopifySectionSelect = this.onSectionSelect.bind(this);
        this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
        document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
        document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
        document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
      }
    }
    disconnectedCallback() {
      if (Shopify.designMode) {
        document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
        document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
        document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
  
        document.body.classList.remove(this.classes.bodyClass);
      }
    }
    onSectionLoad(event) {
      filterShopifyEvent(event, this, () => this.openUpsell.bind(this));
    }
    onSectionSelect(event) {
      filterShopifyEvent(event, this, this.openUpsell.bind(this));
    }
    onSectionDeselect(event) {
      filterShopifyEvent(event, this, this.closeUpsell.bind(this));
    }
    async upsellOpen(event){
      const _this = document.querySelector('upsell-popup')
      _this.nextBtn = document.querySelector('[upsell-popup-next]')
      // prevent form submit to checkout page
      event.preventDefault()
      // initial let for fetch cart
      let cart
      // tape products kit
      let jsonUpsellProducts1 = JSON.parse(document.getElementById('ProductJSON-upsell_products_1').textContent)  
      // product that are in the bag
      let jsonProductsInBag2 = JSON.parse(document.getElementById('ProductJSON-upsell_products_2').textContent) 
      try {
        const response = await fetch(window.routes.cart_url+'.json')
        cart = await response.json()
      } catch (error) {
        console.log(error)
      }
      // product in cart that has 'tape'
      let tape = cart.items.filter(item=> item.product_title.toLowerCase().includes('tape'))
      const filteredTapeOne = jsonUpsellProducts1.length > 0 ? tape.filter((elem) => {
        return !jsonUpsellProducts1.find((ele) => {
        return elem.product_id === ele.id;
      });
    }).flat(1) : tape;
      // tape selected kit is in cart
      const upsell1InCart =jsonUpsellProducts1.map(prod => (
        cart.items.filter(item => item.product_id == prod.id)) ).flat(1)
      // products in cart that match with the ones we select on admin
      let productsInCart2 = jsonProductsInBag2.map(prod => (
      cart.items.filter(item => item.product_id == prod.id)) ).flat(1)
      // product with 'tape' that are not the ones that we select above
      const filteredTapeTwo = productsInCart2.length > 0 ? filteredTapeOne.filter((elem) => {
        return !productsInCart2.find((ele) => {
        return elem.product_id === ele.product_id;
      });
     }).flat(1) : filteredTapeOne;
      
      //hide both
      document.querySelector('#upsell_products_1').style.display='none'
      document.querySelector('#upsell_products_2').style.display='none'

      if(filteredTapeTwo.length > 0 && productsInCart2.length > 0) {
        _this.openUpsell()
        //_this.nextSlideAttribute()
        document.querySelector('#upsell_products_1').style.display='block'
        document.querySelector('#upsell_products_2').style.display='block'
      }
      if(filteredTapeTwo.length > 0 && productsInCart2.length == 0 && upsell1InCart.length == 0){
        _this.openUpsell()
       // _this.togglePopupAttribute()
        document.querySelector('#upsell_products_1').style.display='block'
      }
      if(productsInCart2.length > 0 && filteredTapeTwo.length == 0) {
        _this.openUpsell()
       // _this.togglePopupAttribute()
        document.querySelector('#upsell_products_2').style.display='block'
        if(upsell1InCart.length == 0 ){
          document.querySelector('#upsell_products_1').style.display='block'
        }
      }
      if(filteredTapeTwo.length == 0 && productsInCart2.length == 0){
        _this.closeUpsell()     
      }
      if(filteredTapeTwo.length > 0 && upsell1InCart.length > 0){
        _this.closeUpsell()
      }
    }
}
customElements.define('upsell-popup', UpsellPopup);